import React from "react";
import PhraseWord from "./PhraseWord";
import {PhraseQuestionDefinition} from "../../../state/questions";
import {createUseStyles} from "react-jss";


const useStyles = createUseStyles({
    phrase: {
        display: "flex",
        flexWrap: "wrap",
    },
});

type PhraseProps = {
    question: PhraseQuestionDefinition
}

export const Phrase = ({question}:PhraseProps) => {
    const classes = useStyles();
    return (
        <div className={classes.phrase} data-qa="phrase" data-value={question.phrase}>
        {
            question.phrase.split(" ").map((word, index) =>
                <PhraseWord key={index} word={word}/>
            )
        }
        </div>
    );
};
